import { AccountCreditCardModal, Button } from '@retainerclub/common';
import { CustomerCard } from '@retainerclub/customer-shared';
import { useAccount } from '@retainerclub/hooks';
import { useState } from 'react';
import DashboardLayoutTitleWithPartner from '../../layouts/DashboardLayout/DashboardLayoutTitleWithPartner';
import BillingTableRow from './BillingTableRow';

function Billing() {
  const { accountId, accountCreditCards, accountRefetch } = useAccount();
  const [open, setOpen] = useState(false);

  function handleOpenModal() {
    setOpen(true);
  }

  function handleCloseModal() {
    setOpen(false);

    accountRefetch();
  }

  return (
    <>
      <DashboardLayoutTitleWithPartner
        heading="Credit Card Details"
        title="My Payment Methods"
        subtitle="Manage your payment methods for timely delivery."
      />
      {accountId && (
        <>
          <CustomerCard
            title="Credit Cards"
            action={
              <Button
                onClick={() => handleOpenModal()}
                name="Add New Card"
                add
              />
            }
          >
            {accountCreditCards.length > 0 ? (
              <table className="min-w-full table-auto text-sm">
                <tbody className="divide-y divide-black/10">
                  {accountCreditCards
                    .filter((creditCard) => creditCard.defaultCard)
                    .map((creditCard) => (
                      <BillingTableRow
                        key={creditCard.id}
                        creditCard={creditCard}
                      />
                    ))}
                  {[...accountCreditCards]
                    .sort(
                      (a, b) => new Date(b.createdAt) - new Date(a.createdAt),
                    )
                    .filter((creditCard) => !creditCard.defaultCard)
                    .map((creditCard) => (
                      <BillingTableRow
                        key={creditCard.id}
                        creditCard={creditCard}
                      />
                    ))}
                </tbody>
              </table>
            ) : (
              <p className="text-gray-500 text-sm">
                No credit cards found for your account. Please add one using the
                button above.
              </p>
            )}
          </CustomerCard>

          <AccountCreditCardModal
            open={open}
            handleCloseModal={() => handleCloseModal()}
            accountId={accountId}
          />
        </>
      )}
    </>
  );
}

export default Billing;
